import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { faCalendar, faChevronLeft, faDownload, faExclamationCircle, faFolder, faMedkit, faMoneyBill, faPlus, faTimes, faUser } from '@fortawesome/free-solid-svg-icons';
import { MedicalDetails, Parent, ParentConsent } from 'backend/interfaces/parent.interface';
import { AppointmentService } from 'src/app/services/appointment.service';
import { AppointmentsDialogComponent } from 'src/app/shared/appointments-dialog/appointments-dialog.component';
import { CancelDialogComponent } from 'src/app/shared/cancel-dialog/cancel-dialog.component';
import { ProfilePictureDialogComponent } from 'src/app/shared/profile-picture-dialog/profile-picture-dialog.component';
import { ParentService } from '../services/parent.service';
import { SideNavService, SidenavActions } from '../services/side-nav.service';
import { AlbumDialogComponent } from 'src/app/shared/album-dialog/album-dialog.component';
import { StudentService } from '../services/student.service';
import { BusinessService } from '../services/business.service';
import { Business } from 'backend/interfaces/business.interface';
import { BusinessDataService } from 'src/app/business/services/data.service';
import { DeleteDialogComponent } from 'src/app/shared/delete-dialog/delete-dialog.component';

@Component({
  selector: 'app-client',
  templateUrl: './client.component.html',
  styleUrls: ['./client.component.scss']
})
export class ClientComponent implements OnInit {
  sideNavActions = SidenavActions;
  consentForm: UntypedFormGroup;
  parentId: string;
  saving = false;
  parent: Business;
  loading = false;
  faMedkit = faMedkit;
  faUser = faUser;
  faPlus = faPlus;
  faBill = faMoneyBill;
  faBack = faChevronLeft;
  faTimes  = faTimes;
  faCalendar = faCalendar; 
  faFolder = faFolder;
  faDownload = faDownload;
  parentAppointments: any[] = [];
  parentFile;
  parentFiles = [];
  parentPhotos = [];
  students = [];
  uploadedImage = {name: '', type: '', source: null};
  coverPhotoBaseUrl = '';
  @ViewChild('profilePic') profilePic: ElementRef;
  constructor(private businessService: BusinessService, private router: Router, private ar: ActivatedRoute, public dialog: MatDialog, private sidenav: SideNavService, private studentService: StudentService, private businessDataService: BusinessDataService) { }
  statusArray = ['active', 'inactive'];
  async ngOnInit(): Promise<void> {
    this.loading = true;
    let mainContact = false;
    if(this.ar.snapshot.params['id']){
      this.parentId = this.ar.snapshot.params['id'];
      this.businessDataService.getAdsByBusinessId(this.parentId);
      await this.businessService.getBusinessById(this.parentId);
      this.businessService.activatedBusiness$.subscribe(res => {
        this.parent = res;
        this.businessDataService.business.next(res);
      });
      if(this.parent.DriveId){
        this.studentService.getstudentFiles(this.parent?.DriveId).then(async res => {
            if(res.includes("not found"))
            {
              this.studentService.activatedDrive.next([]);
            }else{
              this.studentService.activatedDrive.next(res);
            }
        });
      }
      this.loading = false;
    } else {
      this.parent = {
        Name: '',
        RegistrationNumber: '',
        RegistrationDate: '',
        Address: '',
        Mobile: '',
        Email: '',
        Status: '',
        Notes: '',
        Category: null,
        InformedDataConsent: false
      };
      this.loading = false;
    }
  }

  async saveProfile(event: Business) {
    this.saving = true;
    this.businessService
      .saveBusiness(event)
      .then(() => {
        this.saving = false;
      })
      .catch((err) => {
        this.saving = false;
      });
  }

  async saveMedical(event: MedicalDetails) {
  }

  async saveParentConsent(event: {parent: ParentConsent, signature: string}) {
    this.saving = true;
    this.businessService
      .saveBusinessConsent(event.parent)
      .then(() => {
        this.saving = false;
        this.router.navigate(['admin','businesses']);
      })
      .catch((err) => {
        console.log(err);
        this.saving = false;
      });
  }

  download() {
    const linkSource = this.parent.Document;
    const downloadLink = document.createElement('a');
    downloadLink.href = linkSource.source;
    downloadLink.target = '_blank';
    downloadLink.download = linkSource.name;
    downloadLink.click();
  }

  cancel(){
    this.parent = null;
    this.parentId = '';
    this.router.navigate(['admin', 'parents']);
  }

  openCancelDialog(): void {
    const dialogRef = this.dialog.open(CancelDialogComponent, {
      data: {title: 'Close Client', question: 'Have you saved your changes?'}
    });
  
    dialogRef.afterClosed().subscribe(result => {
      if(result){
        this.cancel();
      } else {
        this.dialog.closeAll();
      }
    });
  }

  async loadProfile(e: Parent): Promise<void>{
    if(this.ar.snapshot.params['id']) {
      this.loading = true;
      this.parent = null;
      await this.businessService.getBusinessById(e.ID).then(res => {
        this.parent = res;
      });
    } else {
      this.router.navigate(['admin', 'parent', e.ID]);
    }
    this.loading = false;
  }

  openProfilePictureDialog(src?: any): void {
    const dialogRef = this.dialog.open(ProfilePictureDialogComponent, {
      data: {title: 'Upload Picture', parentId: this.parentId, currentPicture: src ? src : ''},
      width: '60%'
    });
  
    dialogRef.afterClosed().subscribe(result => {
      if(result){
        console.log(result);
      } else {
        this.dialog.closeAll();
      }
    });
  }

  viewAppointments(){
    const dialogRef = this.dialog.open(AppointmentsDialogComponent, {
      data: {appointments: this.parentAppointments, parentId: this.parentId },
      width: '60%'
    });
  
    dialogRef.afterClosed().subscribe(result => {
      if(result){
        console.log(result);
      } else {
        this.dialog.closeAll();
      }
    });
  }

  viewDriveFolder(){
    const dialogRef = this.dialog.open(AlbumDialogComponent, {
      data: {parentId: this.parent.RegistrationNumber, albumId: this.parent.DriveId, files: this.parentFiles, type: 'drive' },
      width: '90%',
      maxWidth: '100vw',
      height: '90%',
    });
  
    dialogRef.afterClosed().subscribe(result => {
      if(result){
        console.log(result);
      } else {
        this.dialog.closeAll();
      }
    });
  }

  createDriveFolder(){
    this.loading = true;
    this.businessService.createDriveFolder(this.parent.RegistrationNumber).then(async result => {
      this.router.navigateByUrl('/', {skipLocationChange: true}).then(()=>
      this.router.navigate(['admin', 'parent', {id: this.parent.RegistrationNumber}]));
      this.loading = false;
    });
  }

  async createAccount(): Promise<void>{
    this.loading = true;
    this.businessService.createAccount().then(async result => {
      this.parent.AccountID = result;
      await this.saveProfile(this.parent);
      this.router.navigateByUrl('/', {skipLocationChange: true}).then(()=>
      this.router.navigate(['admin', 'parent', this.parent.RegistrationNumber, 'account']));
      this.loading = false;
    });
  }

  createPhotoAlbum(){
    this.loading = true;
    this.businessService.createPhotoAlbum(this.parent.RegistrationNumber).then(async result => {
      // this.parent.PhotoAlbumId = result.PhotoAlbumId;
      this.router.navigateByUrl('/', {skipLocationChange: true}).then(()=>
      this.router.navigate(['admin', 'parent', {id: this.parent.RegistrationNumber}]));
      this.loading = false;
    });
  }

  uploadPhotos(){
    let description = '';
    this.businessService.uploadFile(this.parent.DriveId, this.uploadedImage, description).then(res => {
      console.log(res)
    });
  }


  viewPhotos(){
    const dialogRef = this.dialog.open(AlbumDialogComponent, {
      data: {parentId: this.parent.RegistrationNumber, albumId: '', files: this.parentPhotos, type: 'photos' },
      width: '90%',
      maxWidth: '100vw',
      height: '90%',
    });
  
    dialogRef.afterClosed().subscribe(result => {
      if(result){
        this.profilePic.nativeElement.src = result;
      } else {
        this.dialog.closeAll();
      }
    });
  }

  viewStudent(id: string){
    this.router.navigate(['admin', 'student', id])
  }

  viewAccount(){
    this.router.navigate(['account'], { relativeTo: this.ar })
  }

  openSideNav(action: SidenavActions): void {
    this.sidenav.open(action);
  }


  deleteBusiness(){
      const dialogRef = this.dialog.open(DeleteDialogComponent, {
        data: {title: 'Delete', question: 'Are you sure you want to delete this item?', id: this.parentId}
      });
    
      dialogRef.afterClosed().subscribe(result => {
        if(result) {
          if(result){
            this.businessService.deleteBusiness(this.parentId).then(res => {
              console.log(res);
            })
          }else{
            this.dialog.closeAll();
          }
        } else {
          this.dialog.closeAll();
        }
      });

  }
}
